import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="relative z-10 bg-navy-900 border-t border-ivory/10 pt-20 pb-10 px-6 md:px-10" data-testid="footer">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-12 pb-16">
          <div>
            <Logo variant="full" className="h-16" />
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-14 gap-y-4">
            {[
              { to: "/collection", label: "The Collection" },
              { to: "/founding-members", label: "Founding Members" },
              { to: "/selection", label: "The Standard" },
              { to: "/private-collection", label: "How It Works" },
              { to: "/about", label: "About" },
              { to: "/apply", label: "Request Consideration" },
              { to: "/invitation", label: "I Have an Invitation" },
            ].map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="text-ivory/55 hover:text-gold transition-colors duration-500 text-[11px] tracking-[0.18em] uppercase"
                data-testid={l.to === "/founding-members" ? "footer-founding-members-link" : undefined}
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
        <div className="gold-rule mb-8" />
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-ivory/40 text-[11px] tracking-[0.2em] uppercase">
            VillaFlow Private Collection — Amalfi Coast
          </p>
          <p className="font-serif text-gold/80 text-lg italic">Every Stay. More Value.</p>
          <Link
            to="/admin"
            className="text-ivory/25 hover:text-ivory/60 transition-colors text-[10px] tracking-[0.2em] uppercase"
            data-testid="footer-admin-link"
          >
            Selection Team Access
          </Link>
        </div>
      </div>
    </footer>
  );
}
